export const APP_PATHS = Object.freeze({
  SKUS: "/skus",
  MY_CART: "/my-cart",
});
